// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","separator":"separator-module--separator--75fgA"};